<template>
  <div class="modal-backdrop fixed top-0 bottom-0 right-0 left-0 flex justify-center items-center py-56">
    <section
      v-if="!noLogin"
      class="modal relative flex flex-col justify-center text-center shadow-lg bg-white pt-12 pb-24 px-20"
    >
      <button class="absolute top-0 right-0 mt-2 mr-3" @click="closeModal">
        <font-awesome-icon :icon="['fas', 'times']" class="text-secondary-lighter"/>
      </button>
      <header class="h2 text-secondary pb-8">
        Heeft u al een account?
      </header>
      <nuxt-link to="/login" class="btn btn-secondary mb-6">
        Login
      </nuxt-link>
      <button class="btn btn-secondary" @click="toggleWithoutLogin">
        Aanmelden zonder login
      </button>
    </section>

    <section v-if="noLogin" class="modal relative flex flex-col shadow-lg bg-white py-12">
      <div class="px-12">
        <button class="absolute top-0 right-0 mt-2 mr-3" @click="closeModal">
          <font-awesome-icon :icon="['fas', 'times']" class="text-secondary-lighter"/>
        </button>
        <header class="h2 text-secondary pb-6">
          Aanmelden
        </header>
      </div>

      <form class="px-12" @submit.prevent="submit">
        <text-field id="first-name" v-model="form.voornaam" placeholder="Voornaam">
          Voornaam
        </text-field>
        <text-field id="last-name" v-model="form.achternaam" placeholder="Achternaam">
          Achternaam
        </text-field>
        <text-field id="email" v-model="form.e_mailadres" type="email" placeholder="E-mailadres">
          E-mailadres
        </text-field>

        <div class="font-bold my-3">
          Foto’s van deze dag waar ik op sta mag je plaatsen:
        </div>

        <checkbox-field v-model="form.fotos_op_website">
          Op de website van MijnSuperkracht.nl
        </checkbox-field>
        <checkbox-field v-model="form.fotos_op_socials">
          Op de social-mediakanalen van Mijn Superkracht
        </checkbox-field>
        <checkbox-field v-model="form.fotos_in_email">
          In e-mails
        </checkbox-field>

        <div class="font-bold my-3">
          Deelnemersbijdrage
        </div>
        <checkbox-field v-model="form.deelnemersbijdrage">
          Ja ik ga akkoord met de deelnemersbijdrage die voor mij van toepassing is
        </checkbox-field>

        <button type="submit" class="btn btn-secondary mt-6" :disabled="loading">
          Aanmelden voor activiteit
        </button>
      </form>
    </section>
  </div>
</template>

<script>
import CheckboxField from '~/components/forms/CheckboxField';
import TextField from '~/components/forms/TextField';
import createAanmelding from '~/graphql/mutations/createAanmelding';

export default {
  name: 'SubscribeToEvent',
  components: {TextField, CheckboxField},
  data: () => ({
    noLogin: false,
    loading: false,
    form: {
      achternaam: null,
      voornaam: null,
      e_mailadres: null,
      fotos_op_website: null,
      fotos_op_socials: null,
      fotos_in_email: null,
      deelnemersbijdrage: null,
    },
  }),
  created() {
    if (this.$auth.loggedIn) {
      this.noLogin = true;
      this.prefillForm();
    }
  },
  methods: {
    closeModal() {
      this.$emit('event:close-modal');
    },
    toggleWithoutLogin() {
      this.noLogin = !this.noLogin;
    },
    async submit() {
      this.loading = true;
      const payload = {...this.form, activiteit_slug: this.$route.params.slug};

      try {
        await this.$apollo.mutate({mutation: createAanmelding, variables: payload});
        this.form = {};
        this.$toast.success('Uw aanmelding is succesvol ontvangen');
        this.closeModal();
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    prefillForm() {
      const user = this.$auth.user;
      this.form = {
        achternaam: user.last_name,
        voornaam: user.first_name,
        e_mailadres: user.email,
        fotos_op_website: null,
        fotos_op_socials: null,
        fotos_in_email: null,
        deelnemersbijdrage: null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  background: rgba(250, 100, 100, 0.4);

  .modal {
    width: 420px;
  }
}
</style>
